export default __webpack_public_path__ + "static/media/support.333e9610.png";